import axios from "axios";
import store from "../../../../../stores/application/index.js.erb";

const prtfAchievementTypePath = `/portfolio/api/prtf_achievement_types`;

const get_token = () => {
    const token = document.querySelector('[name=csrf-token]').content;
    return axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}

const PrtfAchievementKindApiService = {

    index(idType) {
        get_token();
        try {
            return axios.get(`${prtfAchievementTypePath}/${idType}/prtf_achievement_kinds`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, достижения не были загружены",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

    show(idType, idKind) {
        get_token();
        try {
            return axios.get(`${prtfAchievementTypePath}/${idType}/prtf_achievement_kinds/${idKind}`);
        } catch (e) {
            store.dispatch("error_portfolio/addError", {
                type: "Error Server",
                message: "Ошибка сервера, достижения не были загружены",
                context: "Error Server",
                show: true
            });
            return null;
        }
    },

}

export default PrtfAchievementKindApiService;